<template>
	<div>
		<ui-iframe-modal
			v-if="iframeModalUrl != null"
			:src="iframeModalUrl"
			v-on:close="iframeClosed"
			:key="'IFRAME_MODAL_' + iframeModalUrl"
			:dismissible="dismissible"
		/>

		<start-permission-denied-modal
			v-if="showPermissionDeniedModal"
			v-on:close="showPermissionDeniedModal = false"
			:key="'PERMISSION_DENIED_MODAL' + showPermissionDeniedModal"
		/>
	</div>
</template>
<script>
export default {
	data() {
		return {
			iframeModalUrl: null,
			showPermissionDeniedModal: false,
			dismissible: true,
		};
	},
	created() {
		let that = this;
		this.$bus.$off("toggle-iframe-modal");
		this.$bus.$on("toggle-iframe-modal", function (url, dismissible = true) {
			if (url.indexOf("?") == -1) {
				url = url + "?iframe_modal=true";
			}
			that.iframeModalUrl = url;
			that.dismissible = dismissible;
			console.log("IFRAME_MODAL", url);
		});
		this.$bus.$off("toggle-permission-denied-modal");
		this.$bus.$on("toggle-permission-denied-modal", function () {
			that.showPermissionDeniedModal = true;
		});
	},
	methods: {
		iframeClosed() {
			this.iframeModalUrl = null;
			// this.$inertia.reload({ preserveState: false });
			console.log("received iframe closed");
			this.$bus.$emit("iframe close");
			this.$inertia.visit(this.$page.url, {
				method: "get",
				preserveState: true,
				preserveScroll: true,
			});
		},
	},
};
</script>
